import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';
import React, { useState, useEffect } from 'react';

import WsColors from '../../WsColors';

interface ToggleButtonProps {
  isDisabled?: boolean;
  buttonGroupPadding: number;
}
const StyledToggleGroup = styled(ToggleButtonGroup)(
  ({ isDisabled, buttonGroupPadding }: ToggleButtonProps) => ({
    backgroundColor: isDisabled ? WsColors.TheBlues100 : WsColors.TheBlues500,
    padding: buttonGroupPadding,
  })
);
export interface WsToggleObject {
  label: string;
  value: string | number;
}
export interface WsToggleButtonProps {
  buttonsList: Array<WsToggleObject>;
  selectedIndexValue: (value: string | number) => void;
  defaultValue?: string | number;
  disabled?: boolean;
  buttonGroupPadding?: number;
}

const WsToggleButton = ({
  buttonsList,
  selectedIndexValue,
  defaultValue = '',
  disabled = false,
  buttonGroupPadding = 3.2,
}: WsToggleButtonProps) => {
  const [selected, setSelected] = useState<string | number>(defaultValue);
  const onChange = (event: React.MouseEvent<HTMLElement>, value: string | number) => {
    if (value) {
      setSelected(value);
      selectedIndexValue(value);
    }
  };
  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);
  return (
    <StyledToggleGroup
      value={selected}
      exclusive
      defaultChecked
      onChange={onChange}
      disabled={disabled}
      isDisabled={disabled}
      buttonGroupPadding={buttonGroupPadding}
    >
      {buttonsList?.map((btn, index) => (
        <ToggleButton fullWidth key={index} value={btn.value} sx={{ px: 1.3, py: 0.2 }}>
          {btn.label}
        </ToggleButton>
      ))}
    </StyledToggleGroup>
  );
};
export default WsToggleButton;
